/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tools_Quests_CtaInputs */

const en_control_tools_quests_cta = /** @type {(inputs: Control_Tools_Quests_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View quests`)
};

const zh_control_tools_quests_cta = /** @type {(inputs: Control_Tools_Quests_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看任务`)
};

/**
* | output |
* | --- |
* | "View quests" |
*
* @param {Control_Tools_Quests_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tools_quests_cta = /** @type {((inputs?: Control_Tools_Quests_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tools_Quests_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tools_quests_cta(inputs)
	return zh_control_tools_quests_cta(inputs)
});
export { control_tools_quests_cta as "control.tools.quests.cta" }